import axios from '../utils/axios';

export default function createNTCPremiumJobRejectionTag(adminId, data) {
    return axios.post(`/admin/${adminId}/ntc-premium-jobs/rejection-tags`, data)
        .then(res => res.data)
        .catch(err => err);
}
